import createIcon from '../../createIcon';

/**
 * @component @name ArrowDownward
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTJMMTguNTkgMTAuNTlMMTMgMTYuMTdWNEgxMVYxNi4xN0w1LjQyIDEwLjU4TDQgMTJMMTIgMjBMMjAgMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ArrowDownward = createIcon('ArrowDownward', [
  [
    'path',
    { d: 'M20 12L18.59 10.59L13 16.17V4H11V16.17L5.42 10.58L4 12L12 20L20 12Z', key: 'ly6b7w' },
  ],
]);

export default ArrowDownward;
